import Exception from './Exception'

export default class LogicException extends Exception {

}